<template>
  <div class="error">
      <div style="margin-top:100px">
        <div class="title">404</div>
        <span>您访问的页面不存在!</span>
      </div>
  </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style scoped>
    .error{
        display: flex;
        justify-content: center;
        background: #75879D;
        height: 100%;
    }
    .title{
        font-size: 70px;
        font-weight: bold;
        color: #fff;
    }
    span{
        font-size:40px;
        color: #fff;
    }
</style>
